module.exports = __webpack_public_path__ + "img/52_42.f8717cde.png";